<template>
  <textarea
    :class="[style.inputAnswerSurface, mobileVersion ? style.mobile : '']"
    :value="currentQuestionData?.placeholder || ''"
    @input="setPlaceholder"
    :placeholder="'Подсказка'"
    :style="{width: '100%!important'}"
  />
</template>

<script lang="ts">
import {defineComponent} from "vue";
import style from "./InputAnswer.module.scss";

export default defineComponent({
  name: "InputAnswer",
  data() {
    return {
      style
    };
  },
  methods: {
    setPlaceholder(event: Event) {
      const target = event.target as HTMLInputElement;
      if (!this.currentQuestionData) {
        return;
      }

      this.currentQuestionData.placeholder = target.value;
    }
  },
  computed: {
    quiz() {
      return this.$quizStore.getQuiz;
    },
    selectedQuestion() {
      return this.$quizStore.getSelectedQuestion;
    },
    selectedVersion() {
      return this.$quizStore.getSelectedVersion;
    },
    mobileVersion() {
      return this.selectedVersion === "Мобильная";
    },
    currentQuestionData() {
      if (!this.quiz?.questions || this.selectedQuestion < 0) {
        return null;
      }

      return this.quiz.questions[this.selectedQuestion] || null;
    }
  }
});
</script>
